export { FullLogoWhiteIcon } from './FullLogoWhiteIcon';
